/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BoardCass from 'solis/logic/board/cass';
import ColonyCass from 'solis/logic/board/colony/cass';

import Text from 'solis/react/primitive/text';

import BoardAuthority from 'solis/claude/logic/board/authority';

import * as Row from 'solis/claude/card/authority/row';


const getWidth = (colonies, authority) =>
{
  const largest = Math.max(...colonies.map(colony => authority.getNextValue(colony)));

  return String(largest).length + 'ch';
};


const hasScoredBefore = (colony, date) =>
{
  return ColonyCass.of(colony).getScoreFraction(date) === 1;
};


const getScoredRows = ({ colonies, date, ...props }) =>
{
  return colonies.filter(colony => hasScoredBefore(colony, date)).map(colony =>
  (
    <Row.Scored key = {colony.cass.id} colony = {colony} {...props} />
  ));
};


const getPartialRows = ({ colonies, date, ...props }) =>
{
  return colonies.filter(colony => !hasScoredBefore(colony, date)).map(colony =>
  (
    <Row.Partial key = {colony.cass.id} colony = {colony} {...props} />
  ));
};


const PartialNote = () =>
(
  <Text.Note mt = '2'>attached this scoring period</Text.Note>
);


export default ({ board, colonies, now }) =>
{
  const date = BoardCass.of(board).getNextScoreDate(now);

  const authority = BoardAuthority.of(board, date);

  const width = getWidth(colonies, authority);

  const scored = getScoredRows({ colonies, date, authority, width });
  const partial = getPartialRows({ colonies, date, authority, width });

  return partial.length ? [ ...scored, <PartialNote key = 'note' />, ...partial ] : scored;
};
